<div class="flex h-screen overflow-hidden">

  @if (!hideSidebar) {
    <app-sidebar></app-sidebar>
  }

  <div
    [ngClass]="sidebarExpanded ? 'lg:ml-0' : 'lg:ml-0'"
    class="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto"
  >

    <app-header [showSidebarToggle]="!hideSidebar"></app-header>

    <main>
      <div class="p-4 mx-auto md:p-6 w-full">
        <router-outlet></router-outlet>
      </div>
    </main>


  </div>

</div>

<app-notification></app-notification>
<app-toast-container></app-toast-container>
